window.getFilteredMediaIndexes = function (product, variant) {
  let isAltLogicEnabled = window.enableAltLogicMap && window.enableAltLogicMap[product.handle];

  if (isAltLogicEnabled === undefined) {
    const el = document.querySelector(`[data-product-handle="${product.handle}"][data-enable-alt-logic]`);
    if (el) {
      isAltLogicEnabled = el.getAttribute('data-enable-alt-logic') === 'true';
      window.enableAltLogicMap = window.enableAltLogicMap || {};
      window.enableAltLogicMap[product.handle] = isAltLogicEnabled;
    }
  }

  if (!isAltLogicEnabled) {
    const filteredMediaIds = [];
    product["media"].forEach((media) => {
      let matchMedia = variant["featured_media"] && media["position"] === variant["featured_media"]["position"];
      if (media["alt"]?.includes("#") && media["alt"] !== product["title"]) {
        if (!matchMedia) {
          const altParts = media["alt"].split("#"), mediaGroupParts = altParts.pop().split("_");
          product["options"].forEach((option) => {
            if (option["name"].toLowerCase() === mediaGroupParts[0].toLowerCase()) {
              if (variant["options"][option["position"] - 1].toLowerCase() !== mediaGroupParts[1].trim().toLowerCase()) {
                filteredMediaIds.push(media["position"] - 1);
              }
            }
          });
        }
      }
    });
    return filteredMediaIds;
  }
  const filteredMediaIds = [];

  if (!product || !variant) return filteredMediaIds;

  const filterableOptions = ['buckle color', 'buckle style', 'by occasion'];
  const selectedValues = {};
  let hasFilterableOption = false;

  product['options'].forEach((option, index) => {
    const optNameStr = typeof option === 'string' ? option : option['name'];
    const optPosition = typeof option === 'string' ? index + 1 : option['position'];

    if (!optNameStr) return;

    const optName = optNameStr.toLowerCase().trim();
    if (filterableOptions.includes(optName)) {
      const val = variant['options'][optPosition - 1];
      if (val) {
        selectedValues[optName] = val.toLowerCase().replace(/(\w)-(\w)/g, '$1 $2').trim();
        hasFilterableOption = true;
      }
    }
  });

  if (!hasFilterableOption) {
    return filteredMediaIds;
  }


  const validMediaIds = [];
  product['media'].forEach((media) => {
    const alt = (media['alt'] || '').trim();
    const altLower = alt.toLowerCase().replace(/(\w)-(\w)/g, '$1 $2');

    if (alt === '' || alt.includes('|') || alt.includes('*')) {
      return;
    }

    // Split by comma to support multiple exact combinations for a single image
    const altParts = altLower.split(',').map(part => part.trim());

    let isAnyPartMatch = false;

    for (const part of altParts) {
      let isMatch = true;
      for (const [optName, optValue] of Object.entries(selectedValues)) {
        if (!part.includes(optValue)) {
          isMatch = false;
          break;
        }
      }
      if (isMatch) {
        isAnyPartMatch = true;
        break;
      }
    }

    if (!isAnyPartMatch && media.position) {
      filteredMediaIds.push(media.position - 1);
    } else {
      validMediaIds.push(media.id);
    }
  });


  if (variant && variant.featured_media) {
    let dynamicTargetMediaId = variant.featured_media.id;

    // Only proceed if the variant's featured media is NOT hidden by the alt logic
    if (filteredMediaIds.includes(variant.featured_media.position - 1)) {
      // It is hidden! We dynamically find the first valid image for THIS combination
      if (validMediaIds.length > 0) {
        dynamicTargetMediaId = validMediaIds[0];
        console.log("Current selected media id (dynamically found fallback):", dynamicTargetMediaId);
      }
    } else {
      console.log("Current selected media id (not hidden):", dynamicTargetMediaId);
    }

    const productElement = document.querySelector(`[data-product-handle="${product.handle}"]`);
    if (productElement) {
      const mainProduct = productElement.closest('.product');
      if (mainProduct) {
        setTimeout(() => {
          mainProduct.querySelector(`button[data-media-id="${dynamicTargetMediaId}"]`)?.click();
        }, 0);
      }
    }
  }

  return filteredMediaIds;
};
